export const senderCategory = [
  { name: "Customer" },
  { name: "Partner" },
  { name: "Employee" },
  { name: "Other" },
];
